module.exports = __webpack_public_path__ + "static/media/hiw-kitchen-bg-2400x1620.441e7280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/hiw-kitchen-bg-2400x1620.jpg
// module id = 177
// module chunks = 0